import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="detail-toggle"
// Toggles visibility of detail rows and loads content via AJAX if needed
export default class extends Controller {
  async toggle(event) {
    event.preventDefault()

    const link = event.currentTarget
    const href = link.getAttribute('href')

    if (!href || href === '#') return

    const parentRow = link.closest('tr')
    const detailRow = document.querySelector(href)

    if (!detailRow || !parentRow) return

    // If already open, just close it
    if (parentRow.classList.contains('open')) {
      parentRow.classList.remove('open')
      detailRow.classList.remove('open')
      return
    }

    // Check if we need to load content
    const expanded = detailRow.dataset.expanded
    if (expanded !== undefined && expanded === 'false') {
      await this.loadDetailContent(detailRow, href)
    }

    // Open the row
    parentRow.classList.add('open')
    detailRow.classList.add('open')
  }

  async loadDetailContent(detailRow, href) {
    // Determine type and ID from href
    let match
    let url
    let tdSelector

    if (match = href.match(/#master_recording_detail_(\d+)/)) {
      const masterRecordingId = detailRow.dataset.masterRecordingId
      url = this.constructUrl(detailRow, 'master_recording_id', masterRecordingId, '/master_recordings/')

      // Add colcount query param for master_recordings
      const colcount = detailRow.dataset.colcount
      const useFacebox = detailRow.dataset.useFacebox
      const params = []

      if (colcount) {
        params.push(`colcount=${colcount}`)
      }
      if (useFacebox) {
        params.push('use_facebox=true')
      }
      if (params.length > 0) {
        url += `?${params.join('&')}`
      }

      tdSelector = 'td.master_recording-detail'
    } else if (match = href.match(/#(?:project_folders_)?recording_mix_detail_(\d+)/)) {
      const recordingMixId = detailRow.dataset.recordingMixId
      url = this.constructUrl(detailRow, 'recording_mix_id', recordingMixId, '/recording_mixes/')

      // Add use_facebox query param if present
      const useFacebox = detailRow.dataset.useFacebox
      if (useFacebox) {
        url += '?use_facebox=true'
      }

      tdSelector = 'td.recording_mix-detail'
    } else {
      return // Unknown detail type
    }

    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()
      const td = detailRow.querySelector(tdSelector)

      if (td) {
        // Replace the entire td element with the returned HTML
        // Use outerHTML to replace the element including its tag
        td.outerHTML = html

        // Mark as expanded
        // Note: Stimulus will automatically connect the audio-signatures controller
        // when the new HTML with data-controller="audio-signatures" is inserted
        detailRow.dataset.expanded = 'true'

        // Display search score if available
        this.showSearchScore(detailRow)
      }
    } catch (error) {
      console.error('Failed to load detail content:', error)
      alert('Cannot load details')
    }
  }

  constructUrl(detailRow, placeholder, id, fallbackPath) {
    // Use data-full-path if available
    const fullPath = detailRow.dataset.fullPath
    if (fullPath && fullPath !== '') {
      return fullPath.replace(new RegExp(`\\b${placeholder}\\b`), id)
    }

    // Fallback: just use the simple path (e.g., /master_recordings/123)
    return fallbackPath + id
  }

  showSearchScore(detailRow) {
    // Check if this detail row has a search score
    const score = detailRow.dataset.searchScore
    if (score === undefined) return

    // Find the container for the score
    // Account for the audio-signatures wrapper div
    const containingDiv = detailRow.querySelector('td.master_recording-detail div.row > div.col-sm-6:nth-last-of-type(2n)')
    if (!containingDiv) return

    // Create the score display elements
    const newRow = document.createElement('div')
    newRow.className = 'row detail-item'

    const keyDiv = document.createElement('div')
    keyDiv.className = 'col-4 key'
    keyDiv.textContent = 'Score:'

    const valueDiv = document.createElement('div')
    valueDiv.className = 'col-8 value'
    valueDiv.textContent = score

    newRow.appendChild(keyDiv)
    newRow.appendChild(valueDiv)
    containingDiv.appendChild(newRow)
  }
}
